import { createFileRoute } from '@tanstack/react-router'
import { PurchasePrintPage } from '../../../../features/purchasing/purchase-print-page'
import { printSearchSchema } from '../../../../features/sales/search'

export const Route = createFileRoute('/_app/purchases/$purchaseId/print')({
  staticData: { crumb: 'purchasePrint' },
  validateSearch: printSearchSchema,
  component: PurchasePrintPage,
})
